export async function fetchLsQuizData({ token, userId, email, userType, reportId }) {
  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/getLsQuizData`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ user_id: userId, email, user_type: userType, report_id: reportId }),
  });

  if (!resp.ok) {
    const err = await resp.json().catch(() => ({}));
    throw new Error(err.message || "Failed to fetch quiz data");
  }

  return resp.json();
}
